export default "__VITE_ASSET__CmNJOWWJ__"